import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${props => props.theme.spacing.sp4};

  .MuiInputBase-inputMultiline {
    overflow: overlay;
  }
`
